export function titleize(edit_type: string): string {
  const title = edit_type.replace(/_/g, ' ');
  return title.charAt(0).toUpperCase() + title.slice(1);
}
